module.exports = __webpack_public_path__ + "static/media/background-white-rain.0fa718d0.jpg";